import React, { Fragment, useEffect } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl/dist';

// components

import Gears from './Gears';
import { GIButton, Modal } from 'app-components';

// hooks

import { useBroker, useDisclosure } from '../../hooks';

const BROKER_VIEW_PROFILE_URL = '/hix/broker/viewbrokerprofile';
const ASSISTER_VIEW_PROFILE_URL = '/hix/entity/assister/viewAssisterProfile';

// types

interface GearsContainerProps {
    stateCode: string;
    userRole: string;
}

function GearsContainer({ stateCode, userRole }: GearsContainerProps) {

    const { brokerProfile, dedesignateAssister, dedesignateBroker, getBrokerProfile } = useBroker();
    const { isOpen, onOpen, onClose } = useDisclosure();

    useEffect(() => {
        getBrokerProfile(stateCode, userRole);
    }, []);

    const DesignateModal = (props) => {

        return (
                <Modal id="gearsModalContainer" data-testid="modal">
                    <Modal.Header
                        id="gearsModalContainerHeader"
                        titleId={'gears.modal.title'}
                        onHide={props.onHide}
                        titleValues={{
                            firstName: props.firstName,
                            lastName: props.lastName,
                        }}
                    />
                    <Modal.Body>
                        <p>
                            <FormattedMessage
                                id="gears.modal.body"
                                values={{
                                    firstName: props.firstName,
                                    lastName: props.lastName,
                                }}
                            />
                        </p>
                    </Modal.Body>
                    <Modal.Controls>
                        <GIButton
                            id="id_btn_secondary"
                            labelId="button.cancel"
                            variant="secondary"
                            onClickHandler={props.onHide}
                        />{' '}
                        <GIButton
                            id="id_btn"
                            labelId="button.confirm"
                            onClickHandler={props.onConfirm}
                        />
                    </Modal.Controls>
                </Modal>
        );
    };

    const onSelectViewProfile = () => {
        const { encryptedId, role } = brokerProfile;
        window.location.href = role === 'broker' ? `${BROKER_VIEW_PROFILE_URL}/${encryptedId}` : `${ASSISTER_VIEW_PROFILE_URL}/${encryptedId}`;
    };

    const onConfirm = () => {
        const { encryptedId, role } = brokerProfile;
        onClose();
        if (role === 'broker') {
            dedesignateBroker(encryptedId)
                .then(() => {
                    getBrokerProfile();
                })
                .catch(e => {
                    console.error('error in calling dedesignateBroker = ', e);
                });
        } else {
            dedesignateAssister(encryptedId)
                .then(() => {
                    getBrokerProfile();
                })
                .catch(e => {
                    console.error('error in calling dedesignateAssister = ', e);
                });
        }
    };

    if (!brokerProfile) {
        return null;
    }

    let brokerData = {};
    const {
        contactNumber,
        designateStatus,
        firstName,
        lastName,
        isShowGears,
        isShowDedesignateMsg,
        role
    } = brokerProfile;

    if (brokerProfile) {
        const isBroker = role === 'broker';
        const titleId = isBroker ? 'gears.broker.title' : 'gears.assister.title';
        const pendingStatusMsgId = isBroker ? 'gears.broker.designation.request' : 'gears.assister.designation.request';
        const deDesignateMsgId = isBroker ? 'gears.broker.dedesignate.title' : 'gears.assister.dedesignate.title';

        const title = <FormattedMessage id={titleId} />;
        const viewProfileTitle = <FormattedMessage id="common.viewProfile" />;
        const pendingStatusMsg = designateStatus === 'Pending' ? <FormattedMessage id={pendingStatusMsgId} /> : null;
        const currentStatusPending = designateStatus === 'Pending' ? <FormattedMessage id={'designation.status.pending'} /> : null;
        const deDesignateMsg = isShowDedesignateMsg ? <FormattedMessage id={deDesignateMsgId} /> : null;
        const viewProfileUrl = '';
        const deDesignateUrl = '';

        brokerData = {
            name: `${firstName} ${lastName}`,
            contactNumber,
            title,
            pendingStatusMsg,
            currentStatusPending,
            deDesignateMsg,
            viewProfileUrl,
            deDesignateUrl,
            viewProfileTitle
        };
    }

    return (
        <Fragment>
            {
                isShowGears &&
                <Gears {...{ brokerData, onSelectViewProfile, onSelectDedesignateAgent: onOpen }} />
            }
            {
                isOpen && brokerProfile &&
                <DesignateModal {...{ show: isOpen, firstName: brokerProfile.firstName, lastName: brokerProfile.lastName, onHide:  onClose, onConfirm }} />
            }
        </Fragment>
    );
}

const mapStateToProps = state => ({
    stateCode: state.common.environment.stateCode,
    userRole: state.common.environment.user.role
});

export default connect(mapStateToProps)(GearsContainer);